import React from "react";
import { AlertCircle } from "lucide-react";

interface ErrorMessageProps {
  message: string;
  onRetry: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="p-12 text-center">
      <div className="flex justify-center mb-4">
        <AlertCircle className="w-16 h-16 text-red-500" />
      </div>
      <h3 className="text-xl font-semibold text-red-800 mb-2">
        Connection Error
      </h3>
      <p className="text-red-600 mb-4">{message}</p>
      <button
        onClick={onRetry}
        className="bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-4 rounded-lg transition-colors duration-200"
      >
        Retry
      </button>
    </div>
  );
};

export default ErrorMessage;
